import { render } from "./PromoPopup.vue?vue&type=template&id=2c7e094f&scoped=true"
import script from "./PromoPopup.vue?vue&type=script&lang=js"
export * from "./PromoPopup.vue?vue&type=script&lang=js"

import "./PromoPopup.vue?vue&type=style&index=0&id=2c7e094f&lang=scss&scoped=true"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7e094f"]])

export default __exports__